  // 앱/웹 공통: store에서 guestUserId 읽기
  // store에 없으면 query에서 읽기 (웹 다이렉트 접근 대응)
  // query.id 로 명시적으로 새 사주를 지정한 경우 query 가 우선
  const queryId = Number(route.query.id) || null;
  const newId = queryId || mobileSajuLnbStore.guestUserId || null;
  if (newId && (queryId || !mobileSajuLnbStore.guestUserId)) {
    mobileSajuLnbStore.setGuestUserId(newId);
  }<script setup>
// =============== 1. 초기 설정 ===============
import { useStore } from 'vuex';
import { storeToRefs } from 'pinia';

// API
import { fetchBaseServiceAPI } from '@/api/baseServiceApi';

// Composables
import { useGesture } from '@/composables/calendar/useGesture';
import { useAnalysisServices } from '@/composables/saju-insight/useAnalysisServices';
import { useContentRate } from '@/composables/saju-insight/useContentRate';
import { useSajuData } from '@/composables/saju-insight/useSajuData';
import { useRnBridge } from '@/composables/useRnBridge';
import { useYongsinLightData } from '@/composables/yongsinLight/useYongsinLightData';
import { isObjectEmpty, padNumber } from '@/composables/functions';
import { addContentLogAPI } from '@/api/logServiceApi';

// Store
import { useAnalysisStore } from '@/store/modules/analysis';
import { usePaymentsStore } from '@/store/modules/payments';
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';
import { useMobileSajuLnbStore } from '@/store/modules/mobileSajuLnb';

// Components
import ContentsYongsinLight01 from '@/components/saju-insight/yongsin-light/ContentsYongsinLight01.vue';
import ContentsYongsinLight02 from '@/components/saju-insight/yongsin-light/ContentsYongsinLight02.vue';
import ContentsYongsinLight03 from '@/components/saju-insight/yongsin-light/ContentsYongsinLight03.vue';
import ContentsYongsinLight04 from '@/components/saju-insight/yongsin-light/ContentsYongsinLight04.vue';
import ContentsYongsinLight05 from '@/components/saju-insight/yongsin-light/ContentsYongsinLight05.vue';
import ContentsYongsinLight06 from '@/components/saju-insight/yongsin-light/ContentsYongsinLight06.vue';

// 이미지 프리로드용 — 컴포넌트별 이미지
import ImgBalance from '@manseImages/yongsin-light/img-yongsin-balance.png';
import ImgBattery from '@manseImages/yongsin-light/icon-charging-battery.png';
import ImgTrust from '@manseImages/yongsin-light/icon-trust.png';
import ImgClew from '@manseImages/yongsin-light/icon-clew.png';
import ImgArrowDown from '@manseImages/yongsin-light/icon-arrow-down.png';
import ImgOakTree from '@manseImages/yongsin-light/icon-oak-tree.png';
import ImgFire from '@manseImages/yongsin-light/icon-fire.png';
import ImgMountain from '@manseImages/yongsin-light/icon-mountain.png';
import ImgBattle from '@manseImages/yongsin-light/icon-battle.png';
import ImgWater from '@manseImages/yongsin-light/icon-water.png';
import ImgStar from '@manseImages/yongsin-light/icon-star.png';
import ImgGarden from '@manseImages/yongsin-light/icon-garden.png';
import ImgCat from '@manseImages/yongsin-light/img-yongsin-cat.png';
import ImgCatSmall from '@manseImages/yongsin-light/img-yongsin-cat-small.png';
import ImgBears from '@manseImages/yongsin-light/img-yongsin-bears.png';
import ImgRelation from '@manseImages/yongsin-light/img-yongsin-relation.png';
import ImgCatHanging from '@manseImages/yongsin-light/img-yongsin-cat-hanging.png';
import ImgCatPointer from '@manseImages/yongsin-light/img-yongsin-cat-pointer.png';
import ImgCatCheerup from '@manseImages/yongsin-light/img-yongsin-cat-cheerup.png';
import ImgArrowYongsin from '@manseImages/yongsin-light/arrow-yongsin.svg?url';
import ImgArrowHeesin from '@manseImages/yongsin-light/arrow-heesin.svg?url';
import ImgCenterDeco from '@manseImages/yongsin-light/img-yongsin-center-deco.svg?url';
import ImgCatTip from '@manseImages/yongsin-light/img-yongsin-cat-tip.png';
import ImgDancing from '@manseImages/yongsin-light/icon-dancing.png';
import ImgGreekSalad from '@manseImages/yongsin-light/icon-greek-salad.png';
import ImgHouseGarden from '@manseImages/yongsin-light/icon-house-garden.png';
import ImgPeople from '@manseImages/yongsin-light/icon-people.png';
import ImgAlarmClock from '@manseImages/yongsin-light/icon-alarm-clock.png';
import ImgCatClosing from '@manseImages/yongsin-light/img-yongsin-cat-closing-v2.png';
import DetailPanelQuickUsage from '@/components/saju-insight/yongsin-light/DetailPanelQuickUsage.vue';
import PopAnalysisInfo from '@/components/saju-insight/common/PopAnalysisInfo.vue';
import PopAnalysisInfoOther from '@/components/saju-insight/common/PopAnalysisInfoOther.vue';
import AnalysisLoadingOverlay from '@/components/saju-insight/common/AnalysisLoadingOverlay.vue';
import YongsinLightCover from '@/pages/m/saju-insight/components/YongsinLightCover.vue';
import YongsinLightTOC from '@/pages/m/saju-insight/components/YongsinLightTOC.vue';
import AlertComponent from '@/components/common/Alert.vue';
import IconClose01 from '@/components/svg/IconClose01.vue';
import IconList from '@/components/svg/IconList.vue';

provide('fullWidthMode', true);

definePage({ meta: { layout: 'm-saju-insight' } });

const route = useRoute();
const router = useRouter();
const analysisStore = useAnalysisStore();
const analysisDataStore = useAnalysisDataStore();
const paymentsStore = usePaymentsStore();
const mobileSajuLnbStore = useMobileSajuLnbStore();
const { serviceData, serviceContents, fetchContentByKey } = useAnalysisServices();

// =============== 2. Alert / Dialog ===============
const { alertRef, dialogTitle, dialogText, dialogNextUrl, showAlert } = useDialogManager();

// =============== 3. 웹뷰 통신 ===============
const guestUserId = ref(null);
const isInitializing = ref(true);

const { debuggingHandler } = useRnBridge();

// =============== 4. PC 환경 ===============
const store = useStore();
const userId = ref(null);
userId.value = store.getters['user/id'];

// =============== 5. 사주 데이터 ===============
const { initWithValidation, isLoadingSajuData } = useSajuData();

const closeSajuInsight = () => {
  router.push('/saju-service');
};

const initializeSajuData = () =>
  initWithValidation(guestUserId.value, { showAlert, onRestricted: closeSajuInsight });

// =============== 6. 용신라이트 데이터 ===============
const ANALYSIS_TYPE_ID = 41;

const isLoadingData = ref(false);
const apiRawData = ref(null);

const { content02Data, content03Data, content04Data, content05Data, content06Data, quickUsageData } =
  useYongsinLightData(apiRawData);

const fetchYongsinLightData = async (forceLoad = false) => {
  if (!forceLoad && !serviceData.yongsinLight.permission.value) return;
  isLoadingData.value = true;
  apiRawData.value = null;
  try {
    const result = await fetchBaseServiceAPI({
      guestUserId: guestUserId.value,
      suggestionFlag: 2,
      analysisTypeId: ANALYSIS_TYPE_ID,
    });
    if (result?.success) {
      apiRawData.value = result.data;
    }
  } catch (e) {
    debuggingHandler({ action: 'error', message: `용신라이트 > API 요청 실패: ${e}` });
  } finally {
    isLoadingData.value = false;
  }
};

// =============== 6-1. 이용중인 분석 정보 ===============
const getAnalysisInfo = async () => {
  try {
    await fetchContentByKey('yongsinLight');
  } catch (e) {
    debuggingHandler({
      action: 'error',
      message: `용신라이트 > 이용중인 분석 정보 요청 실패: ${e}`,
    });
  }
};

// =============== 6-2. 페이지 데이터 새로고침 ===============
const isRefreshingPageData = ref(false);

const refreshPageData = async () => {
  isRefreshingPageData.value = true;
  try {
    await Promise.all([
      getAnalysisInfo(),
      // 권한(canAccess) + 이용내역(만료일 등)을 access로 통합 조회 (타입별 /analysis/log 제거)
      analysisStore.fetchAnalysisAccess(guestUserId.value, [ANALYSIS_TYPE_ID]),
      paymentsStore.fetchTicketCount(),
      paymentsStore.getOwnPoint(),
    ]);
    await fetchYongsinLightData();
  } catch (e) {
    debuggingHandler({ action: 'error', message: `용신라이트 > 페이지 새로고침 실패: ${e}` });
  } finally {
    isRefreshingPageData.value = false;
  }
};

// =============== 7. 컨텐츠 평가 ===============
const { ratingResult, ratingStatus, getRate, postRate } = useContentRate(
  'YONGSIN_LIGHT_ANALYSIS',
  guestUserId,
);

// =============== 8. 페이지 상태 ===============
const currentPage = ref(0);
const totalPages = 12;
const showSummary02 = ref(false); // 표지(false) ↔ 목차(true) 토글

const showPopAnalysisInfo = ref(false);
const showPopAnalysisInfoOther = ref(false);

const goToCoverPage = () => {
  currentPage.value = 0;
  showSummary02.value = false;
};

const handelShowSummary02Open = () => {
  showSummary02.value = true;
  window.scrollTo(0, 0);
  // 목차 진입 시 Content01 이미지 미리 로드
  preloadImages(0);
};

// =============== 9. 결제 팝업 ===============
const showPopAnalysisInfoDo = async () => {
  if (isRefreshingPageData.value) return;

  if (serviceData.yongsinLight.permission.value) {
    showPopAnalysisInfo.value = false;
    showPopAnalysisInfoOther.value = false;
    return;
  }

  if (
    paymentsStore?.points < serviceContents.yongsinLight.value?.pointPrice &&
    serviceData.yongsinLight.ticketCount.value === 0
  ) {
    showPopAnalysisInfoOther.value = false;
    showPopAnalysisInfo.value = true;
  } else {
    showPopAnalysisInfoOther.value = true;
    showPopAnalysisInfo.value = false;
  }
};

const handleClosePop = () => {
  showPopAnalysisInfo.value = false;
};

const handleChargePop = (shortageAmount) => {
  router.push({ path: '/purchase/points', query: { next: route.fullPath, shortageAmount } });
  showPopAnalysisInfo.value = false;
};

const handleClosePopOther = () => {
  showPopAnalysisInfoOther.value = false;
};

const handleChargePopOtherProduct = () => {
  router.push('/purchase/tickets');
  showPopAnalysisInfoOther.value = false;
};

const paymentSuccessDo = async (success) => {
  if (success) {
    try {
      await Promise.all([
        getAnalysisInfo(),
        // 결제로 canAccess·이용내역이 바뀌므로 access 재조회 (타입별 /analysis/log 제거)
        analysisStore.fetchAnalysisAccess(guestUserId.value, [ANALYSIS_TYPE_ID]),
        paymentsStore.fetchTicketCount(),
        paymentsStore.getOwnPoint(),
      ]);
      // 결제 직후이므로 permission 체크 우회하여 강제 로드
      await fetchYongsinLightData(true);
      await getRate();
      mobileSajuLnbStore.setNeedRefresh(true);
      // 구매 후 유료 콘텐츠 시작 페이지(모바일 3페이지 = Content02 left)로 이동
      currentPage.value = 3;
    } catch (e) {
      debuggingHandler({ action: 'error', message: `용신라이트 결제 후 새로고침 오류: ${e}` });
    }
  }
};

// =============== 10. 페이지 네비게이션 ===============
const clickPrevPage = () => {
  if (currentPage.value < 1) return;
  currentPage.value -= 1;
  window.scrollTo(0, 0);
};

const clickNextPage = () => {
  // page 2 → 3 진입 시 paywall 체크 (Content02부터 유료)
  if (currentPage.value === 2 && !serviceData.yongsinLight.permission.value) {
    showPopAnalysisInfoDo();
    return;
  }
  if (currentPage.value >= totalPages) goToCoverPage();
  else currentPage.value += 1;
  window.scrollTo(0, 0);
};

// 키보드 방향키 (개발용)
const onKeydown = (e) => {
  if (e.key === 'ArrowLeft') clickPrevPage();
  else if (e.key === 'ArrowRight') clickNextPage();
};
onMounted(() => window.addEventListener('keydown', onKeydown));
onUnmounted(() => window.removeEventListener('keydown', onKeydown));

const { handleStart, handleMove, handleEnd } = useGesture({
  onSwipeLeft: clickNextPage,
  onSwipeRight: clickPrevPage,
  SWIPE_THRESHOLD: 150,
});

// =============== 11. 목차 ===============
const MOBILE_YSL_CONTENTS = [
  { id: 1, title: '📖 용신이란 무엇일까요?' },
  { id: 3, title: '1. 내 사주에서 나를 돕는 기운!' },
  { id: 5, title: '2. 나를 도와주는 중심 기운과 보조 기운' },
  { id: 6, title: '3. 오행의 성향과 나에게 힘을 주는 오행' },
  { id: 7, title: '4. 나는 어떤 타입일까?' },
  { id: 9, title: '5. 지금 나에게 흐르는 기운' },
  { id: 10, title: '6. 생활 속 활용 아이디어' },
];

/** 목차 인덱스 → 페이지 매핑 (TOC 컴포넌트에서 사용) */
const SECTION_PAGE_MAP = { 0: 1, 1: 3, 2: 5, 3: 6, 4: 7, 5: 9, 6: 10 };

/** 목차 전환 직전 페이지 → 다음 섹션 버튼 라벨 */
const NEXT_SECTION_BTN_TITLES = {
  2: '1. 내 사주에서 나를 돕는 기운! →',
  4: '2. 나를 도와주는 중심 기운과 보조 기운 →',
  5: '3. 오행의 성향과 나에게 힘을 주는 오행 →',
  6: '4. 나는 어떤 타입일까? →',
  8: '5. 지금 나에게 흐르는 기운 →',
  9: '6. 생활 속 활용 아이디어 →',
};
// Content01 오른쪽 탭 상태 (page 2는 activeTab === 'more'일 때만 노출)
const content01ActiveTab = ref('why');
const handleContent01TabUpdate = (val) => (content01ActiveTab.value = val);
const nextSectionBtnTitle = computed(() => {
  const title = NEXT_SECTION_BTN_TITLES[currentPage.value];
  if (!title) return '';
  if (currentPage.value === 2 && content01ActiveTab.value !== 'more') return '';
  return title;
});

const openFlag = ref('');
const openContentsList = () => {
  openFlag.value = openFlag.value === '' ? 'open' : '';
};
const closeContentsList = () => (openFlag.value = '');

const updateIndexNo = (id) => {
  if (id > 2 && !serviceData.yongsinLight.permission.value) {
    showPopAnalysisInfoDo();
    return;
  }
  addContentLogAPI({
    contentType: serviceData.yongsinLight.permission.value
      ? 'ay_yongsin_light_toc_paid_opt3'
      : 'ay_yongsin_light_toc_free_opt3',
    option3: String(id),
  });
  currentPage.value = id;
  closeContentsList();
};

const handleNavigateToPage = (tocIdx) => {
  const mappedPage = SECTION_PAGE_MAP[tocIdx];
  if (mappedPage !== undefined) {
    updateIndexNo(mappedPage);
  }
};

// =============== 12. 컴포넌트 매핑 ===============
const contentComponentMap = {
  1: ContentsYongsinLight01,
  2: ContentsYongsinLight01,
  3: ContentsYongsinLight02,
  4: ContentsYongsinLight02,
  5: ContentsYongsinLight03,
  6: ContentsYongsinLight03,
  7: ContentsYongsinLight04,
  8: ContentsYongsinLight04,
  9: ContentsYongsinLight05,
  10: ContentsYongsinLight05,
  11: ContentsYongsinLight06,
  12: ContentsYongsinLight06,
};

const getComponentByPage = (page) => contentComponentMap[page] || null;
const getComponentClass = (page) =>
  page % 2 === 1 ? 'mobile-content-first' : 'mobile-content-second';

const getContentData = (page) => {
  if (page >= 3 && page <= 4) return content02Data.value;
  if (page >= 5 && page <= 6) return content03Data.value;
  if (page >= 7 && page <= 8) return content04Data.value;
  if (page >= 9 && page <= 10) return content05Data.value;
  if (page >= 11 && page <= 12) return content06Data.value;
  return null;
};

// =============== 12-1. 다음 페이지 이미지 프리로드 ===============
// 컴포넌트 단위로 그룹핑: Content01(page 1~2), Content02(3~4), ...
const COMPONENT_IMAGES = [
  /* Content01 */ [ImgBalance, ImgBattery, ImgTrust, ImgClew, ImgArrowDown, ImgOakTree, ImgFire, ImgMountain, ImgBattle, ImgWater, ImgStar, ImgGarden, ImgCat, ImgCatSmall, ImgBears, ImgRelation],
  /* Content02 */ [ImgCatHanging, ImgOakTree, ImgFire, ImgMountain, ImgBattle, ImgWater, ImgCatPointer, ImgCatCheerup, ImgArrowYongsin, ImgArrowHeesin],
  /* Content03 */ [ImgCenterDeco, ImgOakTree, ImgFire, ImgMountain, ImgBattle, ImgWater, ImgArrowYongsin, ImgArrowHeesin],
  /* Content04 */ [],
  /* Content05 */ [ImgCatTip, ImgDancing, ImgGreekSalad, ImgHouseGarden, ImgPeople, ImgAlarmClock],
  /* Content06 */ [ImgCatClosing],
];

const preloadedGroups = new Set();

const preloadImages = (groupIndex) => {
  if (groupIndex < 0 || groupIndex >= COMPONENT_IMAGES.length) return;
  if (preloadedGroups.has(groupIndex)) return;
  preloadedGroups.add(groupIndex);
  COMPONENT_IMAGES[groupIndex].forEach((src) => {
    if (typeof src === 'string' && src.length > 0) {
      const img = new Image();
      img.src = src;
    }
  });
};

// 페이지 → 컴포넌트 그룹 인덱스: page 1~2 → 0, 3~4 → 1, ...
const pageToGroup = (page) => Math.floor((page - 1) / 2);

// =============== 13. 빠르게 활용해보기 팝업 ===============
const showQuickUsage = ref(false);
const openQuickUsage = () => {
  if (isRefreshingPageData.value) return;
  if (!serviceData.yongsinLight.permission.value) {
    showPopAnalysisInfoDo();
    return;
  }
  showQuickUsage.value = true;
};
const closeQuickUsage = () => {
  showQuickUsage.value = false;
};

// =============== 14. 공통 액션 ===============
const close = () => {
  router.push(`/m/saju-insight/${guestUserId.value}`);
};

const resetPopup = () => {
  currentPage.value = 0;
  showSummary02.value = false;
  showQuickUsage.value = false;
};

const onClickRecharge = (shortageAmount) => {
  router.push({
    path: '/purchase/points',
    query: { next: route.fullPath, shortageAmount },
  });
};

// =============== 15. Watch ===============
watch(
  () => mobileSajuLnbStore.guestUserId,
  (newId) => {
    if (newId) guestUserId.value = newId;
  },
);

watch(guestUserId, async (newId, oldId) => {
  if (newId && newId !== oldId) {
    const result = await initializeSajuData();
    if (result?.failed || result?.unknownTime || result?.futureSaju) return;
    await refreshPageData();
    await getRate();
  }
});

watch(currentPage, (newPage) => {
  analysisStore.setYongsinLightIndex(newPage);
  // 페이지 전환 시 스크롤 맨 위로 초기화
  nextTick(() => {
    const inner = document.querySelector('.pop-ana-saju-reading-inner');
    if (inner) inner.scrollTop = 0;
    window.scrollTo(0, 0);
  });
  // 다음 컴포넌트 이미지 프리로드
  if (newPage >= 1) {
    const currentGroup = pageToGroup(newPage);
    preloadImages(currentGroup + 1);
  }
});

watch(
  () => analysisStore.selectedContentIndex,
  (newIdx) => {
    const target = SECTION_PAGE_MAP[newIdx];
    if (target) updateIndexNo(target);
  },
);

// =============== 16. 라이프사이클 ===============
onMounted(async () => {
  // 웹 환경: 비로그인 접근 차단
  if (!userId.value && !sessionStorage.getItem('X-Token')) {
    showAlert({ title: '로그인 후 이용 가능합니다.', nextUrl: () => router.push('/auth/login') });
    return;
  }

  // query.id 로 명시적으로 새 사주를 지정한 경우 query 가 우선
  const queryId = Number(route.query.id) || null;
  const newId = queryId || mobileSajuLnbStore.guestUserId || null;

  // 새로고침 등으로 guestUserId가 없으면 상세분석 홈으로 복귀
  if (!newId) {
    router.replace('/saju-service');
    return;
  }

  if (newId && (queryId || !mobileSajuLnbStore.guestUserId)) {
    mobileSajuLnbStore.setGuestUserId(newId);
  }

  isInitializing.value = false;

  guestUserId.value = null;
  await nextTick();
  guestUserId.value = newId;
});

onUnmounted(() => {
  analysisStore.setYongsinLightIndex(1);
  analysisStore.setSelectedContentIndex(null);
});
</script>

<template>
  <!-- 분석권 및 포인트 부족 -->
  <PopAnalysisInfo
    :isVisible="showPopAnalysisInfo"
    :analysisType="serviceContents.yongsinLight.value"
    :ticketCountData="serviceData.yongsinLight.ticketData.value"
    :ticketCount="serviceData.yongsinLight.ticketCount.value"
    @close="handleClosePop"
    @charge="handleChargePop"
  />
  <!-- 분석권 또는 포인트 사용 가능 -->
  <PopAnalysisInfoOther
    :isVisible="showPopAnalysisInfoOther"
    :analysisType="serviceContents.yongsinLight.value"
    :paymentsStore="paymentsStore"
    :ticketCountData="serviceData.yongsinLight.ticketData.value"
    :ticketCount="serviceData.yongsinLight.ticketCount.value"
    @close="handleClosePopOther"
    @charge="handleChargePopOtherProduct"
    @payment-success="paymentSuccessDo"
  />

  <div
    class="pop-saju-reading-container mobile st-analysis-yongsin-light"
    @mousedown="handleStart"
    @mousemove="handleMove"
    @mouseup="handleEnd"
    @touchstart="handleStart"
    @touchmove="handleMove"
    @touchend="handleEnd"
  >
    <AnalysisMobileHeader title="나를 돕는 기운(용신)" :guestUserId="guestUserId" @close="close" />

    <!-- ═══ 커버 페이지 ═══ -->
    <div v-if="currentPage === 0" class="pop-ana-saju-reading-inner intro">
      <YongsinLightCover
        v-if="currentPage === 0 && !showSummary02"
        :guestUserId="guestUserId"
        :guestUserName="analysisStore.userName || mobileSajuLnbStore?.userName"
        :getAnalysisLogDataList="serviceData.yongsinLight.logData.value"
        :hasPermission="serviceData.yongsinLight.permission.value"
        :loadingTicketInfo="analysisStore.loadingTicketInfo"
        @handleNavigateToPage="handleNavigateToPage"
        @handelShowSummary02Open="handelShowSummary02Open"
        @recharge="onClickRecharge"
      />
      <AnalysisLoadingOverlay
        :loading="
          currentPage === 0 &&
          showSummary02 &&
          (isInitializing || isLoadingSajuData || isRefreshingPageData)
        "
        :message="'용신 라이트 분석중입니다!'"
      />
      <YongsinLightTOC
        v-if="currentPage === 0 && showSummary02 && !isRefreshingPageData"
        :guestUserName="analysisStore.userName || mobileSajuLnbStore?.userName"
        :ticketCount="paymentsStore?.analysisTicketCount || 0"
        :hasPermission="serviceData.yongsinLight.permission.value"
        :initializing="isInitializing || isLoadingSajuData || isRefreshingPageData"
        @navigateToPage="handleNavigateToPage"
        @updateShowSummary02="(value) => (showSummary02 = value)"
        @goPopAnalysis="showPopAnalysisInfoDo"
        @recharge="onClickRecharge"
      />
    </div>

    <!-- ═══ 콘텐츠 페이지 (1~12) ═══ -->
    <div
      v-if="currentPage >= 1 && currentPage <= 12"
      class="pop-ana-saju-reading-inner st-page st-content-page st-app-yongsin-light"
    >
      <AnalysisLoadingOverlay
        :loading="isLoadingData || isRefreshingPageData"
        :message="'용신 라이트 분석중입니다!'"
      />
      <div class="pop-body mobile" :class="{ 'has-next-section-btn': !!nextSectionBtnTitle }">
        <component
          :is="getComponentByPage(currentPage)"
          :class="getComponentClass(currentPage)"
          :isMobile="true"
          :contentData="getContentData(currentPage)"
          :activeSide="currentPage % 2 === 1 ? 'left' : 'right'"
          :ratingResult="currentPage >= 11 ? ratingResult : undefined"
          :ratingStatus="currentPage >= 11 ? ratingStatus : undefined"
          @postRate="postRate"
          @goToOverView="goToCoverPage"
          @update:activeTab="handleContent01TabUpdate"
        />

        <!-- 목차 전환 직전 페이지: 다음 섹션 이동 버튼 -->
        <div
          v-if="nextSectionBtnTitle"
          class="ysl-next-section-btn-wrap"
          :class="`ysl-next-section-btn-wrap--page-${currentPage}`"
        >
          <button class="ysl-next-section-btn" @click="clickNextPage">
            {{ nextSectionBtnTitle }}
          </button>
        </div>
      </div>

      <!-- 목차 리스트 + 페이지네이션 -->
      <div class="contentsListBtnBox mobile">
        <div class="list-box" :class="openFlag">
          <ul class="list-li-box">
            <li
              class="li mobile"
              :class="{ 'li--locked': !serviceData.yongsinLight.permission.value }"
              v-for="item in MOBILE_YSL_CONTENTS"
              :key="item.id"
              @click="serviceData.yongsinLight.permission.value && updateIndexNo(item.id)"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="pop-footer-page-box">
        <div class="pop-desc-box">
          <button class="btn-desc" @click="openQuickUsage">나의 용신 한 눈에</button>
        </div>
        <div class="pop-pagination">
          <IconList
            @click="openContentsList"
            v-if="openFlag === ''"
            style="margin-top: 3px"
          />
          <IconClose01
            @click="openContentsList"
            v-if="openFlag === 'open'"
            style="margin-top: 3px"
          />
          <button class="pop-pagination__prev" @click="clickPrevPage">
            <i class="icon-chevron"></i>
          </button>
          <div class="pop-pagination__index" @click="openContentsList">
            {{ padNumber(currentPage) }} / {{ totalPages }}
          </div>
          <button class="pop-pagination__next" @click="clickNextPage">
            <i class="icon-chevron right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Content06 전용 섹션 제거 → 1~12 통합 처리 -->
  </div>

  <!-- 빠르게 활용해보기 팝업 -->
  <div class="pop-desc-layer">
    <div v-if="showQuickUsage" class="pop-desc-overlay" @click="closeQuickUsage">
      <Transition name="slide-up">
        <div class="pop-desc-content" @click.stop>
          <div class="pop-desc-header">
            <div class="desc-nav">
              <h3 class="active">나의 용신 한 눈에</h3>
            </div>
            <button class="pop-header-desc__close" @click="closeQuickUsage"></button>
          </div>
          <div class="pop-desc-body">
            <DetailPanelQuickUsage :contentData="quickUsageData" />
          </div>
        </div>
      </Transition>
    </div>
  </div>

  <AlertComponent ref="alertRef" :title="dialogTitle" :text="dialogText" :nextUrl="dialogNextUrl" />
</template>

<style lang="scss">
@import '@/assets/nangman_style/popup/saju-reading_mobile.scss';
@import '@/assets/nangman_style/mobile/saju-reading-common.scss';
@import '@/assets/nangman_style/mobile/saju-reading-common-page.scss';

/* 네이버 인앱브라우저 주소창 오버레이 방지: 문서 레벨 스크롤 전환 */
.pop-saju-reading-container.mobile.st-analysis-yongsin-light {
  height: auto;
  min-height: 100vh;
  overflow: visible;

  > .header {
    position: sticky;
    top: 0;
    z-index: 20;
  }
}

// ── 목차 전환 직전 페이지: 다음 섹션 이동 버튼 ──
.st-analysis-yongsin-light {
  // 모바일은 document-level 스크롤을 사용하므로 카드 내부 중첩 스크롤을 제거한다.
  // (중첩 스크롤이 있으면 내부가 먼저 끝난 뒤 외부 스크롤로 넘어가면서 "한 번 걸리는" 체감이 생김)
  .pop-body .ysl-card {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }
  .pop-body .ysl-content {
    flex: 0 0 auto !important;
    overflow: visible !important;
  }

  // 버튼이 노출되는 페이지는 카드 내부 .ysl-content 하단 여백을 줄여
  // 버튼이 본문 바로 아래에 위치하도록 통일한다.
  .pop-body.has-next-section-btn .ysl-content {
    padding-bottom: 16px !important;
  }

  .ysl-next-section-btn-wrap {
    display: flex;
    justify-content: center;
    padding: 16px 20px 24px;
    background: #fff;
  }

  // Content03(page 5, 6)는 .ysl-content 배경이 #f8f8f8 이므로
  // 버튼 래퍼도 같은 톤으로 이어지게 한다.
  .ysl-next-section-btn-wrap--page-5,
  .ysl-next-section-btn-wrap--page-6 {
    background: #f8f8f8;
  }

  .ysl-next-section-btn {
    width: 330px;
    max-width: 100%;
    padding: 14px 20px;
    border: none;
    border-radius: 100px;
    background: #4e80d6;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
    color: #fff;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    cursor: pointer;
    transition: opacity 0.2s;
    word-break: keep-all;

    &:hover {
      opacity: 0.9;
    }
  }
}

// ── 용신라이트 모바일 공통 ──
.st-analysis-yongsin-light {
  .pop-ana-saju-reading-inner,
  .overview-cover {
    background: #dce8fb;
  }

  /* 목차 표시 시 커버 배경색 대신 흰색 (문서 레벨 스크롤에서 하단 여백 방지) */
  .pop-ana-saju-reading-inner.intro:has(.detailed-overview) {
    background: #fff;
  }

  .pop-ana-saju-reading-inner .pop-body {
    background: #fff;
  }

  .pop-ana-saju-reading-inner.st-content-page {
    background-color: #fff !important;
    padding-bottom: calc(52px + var(--safe-area-bottom, 0px));
    overflow-x: hidden !important;

    .contentsListBtnBox.mobile {
      position: fixed;
      bottom: calc(52px + var(--safe-area-bottom, 0px));
      right: 0;
    }
  }
}

.pop-ana-saju-reading-inner {
  height: auto;
  min-height: calc(100vh - 52px - var(--safe-area-top, 0px));
  overflow: visible;

  &.intro {
    overflow: visible;
    padding-bottom: var(--safe-area-bottom, 0px);
  }

  &.st-page {
    height: auto;
    min-height: calc(100vh - 52px - var(--safe-area-top, 0px));
    overflow: visible;
    padding-bottom: calc(52px + var(--safe-area-bottom, 0px));
  }

  .btn-footer-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    .btn-white {
      display: flex;
      width: 100%;
      height: 48px;
      padding: 14px 20px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 6px;
      border: 1px solid var(--Gray-300, #ebebeb);
      background: var(--gray-100-white, #fff);
      box-shadow: 0px -10px 10px 0px rgba(0, 0, 0, 0.05);
      color: #333;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }
  }
  .pop-body {
    height: auto;
    padding: 0px;
    flex: 1;
    overflow: visible;

    .v-row {
      margin: 0px !important;
    }

    &.rating {
      height: 100%;
    }
  }
}

// ── 빠르게 활용해보기 팝업 ──
.pop-desc-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
}

.pop-desc-content {
  width: 100%;
  border-radius: 28px 28px 0px 0px;
  background: var(--gray-100-white, #fff);
  height: calc(100vh - 20px - var(--safe-area-top, 0px));
  height: calc(100dvh - 20px - var(--safe-area-top, 0px));
  display: flex;
  flex-direction: column;
  padding-top: 8px;
}

.pop-header-desc__close {
  display: flex;
  position: absolute;
  z-index: 1000;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  border: none;
  background: url('/src/assets/images_manse/icon_close_1.svg') no-repeat !important;
  background-size: contain;
  cursor: pointer;
}

.pop-desc-header {
  position: relative;
  display: flex;
  width: 100%;
  height: 52px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid var(--Gray-300, #ebebeb);

  .desc-nav {
    display: flex;
    align-items: flex-start;
    gap: 28px;
  }

  h3 {
    color: var(--Gray-600, #757575);
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    position: relative;
    display: flex;
    padding: 16px 0px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    &.active {
      color: var(--orange-300-main, #eb4c10);
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: var(--orange-300-main, #eb4c10);
      }
    }
  }
}

.pop-desc-body {
  padding: 20px 16px;
  flex: 1;
  overflow-y: auto;
}

// ── slide-up 트랜지션 ──
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}

// ── mobile-content-first / mobile-content-second ──
.mobile-content-first {
  .mobile-second {
    display: none;
  }
}

.mobile-content-second {
  .mobile-first {
    display: none;
  }
}
</style>
